import unescapedText from 'I18n/utils/unescapedText';
import { Flex } from 'foundations-components/components/Flex';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { HamburgerMenuIcon } from 'foundations-assets/icons/components/HamburgerMenuIcon';
import { useLogo, useCompanyName } from '../context/PortalDataContext';
import { MyAccountPopover } from './MyAccountPopover';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function PortalsTopBar({
  onHamburgerClick,
  isDrawerOpen,
  shouldShowSideNav,
  logoAccessory: logoAccessoryProp,
  headerStart,
  navBackgroundColor
}) {
  var _ref, _logo$alt;
  const logoAccessory = logoAccessoryProp !== null && logoAccessoryProp !== void 0 ? logoAccessoryProp : headerStart;
  const logo = useLogo();
  const companyName = useCompanyName();
  const borderProps = !shouldShowSideNav ? {
    borderBlockEndWidth: '100',
    borderBlockEndColor: 'fill-surface-raised',
    borderBlockEndStyle: 'solid'
  } : {};
  const logoImg = logo !== null && logo !== void 0 && logo.src ? /*#__PURE__*/_jsx("img", {
    src: logo.src,
    alt: (_ref = (_logo$alt = logo.alt) !== null && _logo$alt !== void 0 ? _logo$alt : logo.name) !== null && _ref !== void 0 ? _ref : 'Logo',
    style: {
      maxHeight: '32px',
      maxWidth: '120px'
    }
  }) : companyName ? /*#__PURE__*/_jsx(TruncateString, {
    maxInlineSize: "215px",
    textAlign: "center"
    // @ts-ignore need to set this to get font family styles
    ,
    typography: "heading-200",
    color: "text-core-default",
    "data-test-id": "portals-logo-fallback",
    children: companyName
  }) : null;
  return /*#__PURE__*/_jsxs(Flex, Object.assign({
    alignItems: "center",
    blockSize: "56px",
    backgroundColor: navBackgroundColor,
    flexShrink: "0",
    paddingInline: "200",
    "data-test-id": "portals-top-bar"
  }, borderProps, {
    children: [/*#__PURE__*/_jsx(Flex, {
      flexGrow: "1",
      flexBasis: "0",
      alignItems: "center",
      minInlineSize: "0",
      children: shouldShowSideNav ? /*#__PURE__*/_jsx(IconButton, {
        onClick: onHamburgerClick,
        "aria-label": unescapedText('app.topBar.openNavigation'),
        "aria-expanded": isDrawerOpen,
        "aria-controls": "portals-nav-drawer",
        tooltip: unescapedText('app.topBar.openNavigation'),
        use: "transparent",
        "data-test-id": "portals-top-bar-hamburger",
        children: /*#__PURE__*/_jsx(HamburgerMenuIcon, {})
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [logoImg, logoAccessory !== null && logoAccessory !== void 0 ? logoAccessory : null]
      })
    }), shouldShowSideNav ? /*#__PURE__*/_jsxs(Flex, {
      flexGrow: "1",
      flexBasis: "0",
      alignItems: "center",
      justifyContent: "center",
      minInlineSize: "0",
      children: [logoImg, logoAccessory !== null && logoAccessory !== void 0 ? logoAccessory : null]
    }) : null, /*#__PURE__*/_jsx(Flex, {
      flexGrow: "1",
      flexBasis: "0",
      alignItems: "center",
      justifyContent: "end",
      gap: "200",
      minInlineSize: "0",
      children: /*#__PURE__*/_jsx(Flex, {
        flexShrink: "0",
        alignItems: "center",
        justifyContent: "center",
        children: /*#__PURE__*/_jsx(MyAccountPopover, {})
      })
    })]
  }));
}